// extracted by mini-css-extract-plugin
export var box = "_k-2";
export var checkboxControl = "_k-0";
export var checkboxRow = "_k-a";
export var checked = "_k-3";
export var descriptionSpacer = "_k-c";
export var disabled = "_k-4";
export var icon = "_k-8";
export var input = "_k-1";
export var labelSpacer = "_k-b";
export var large = "_k-7";
export var medium = "_k-6";
export var small = "_k-5";
export var text = "_k-9";